import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { withRouter } from "react-router-dom";
import MyChallans from "./component";
import {
    createChallanProspectLead,
    getChallanList,
    getChallanProspectLeadDetails,
    checkLeadPhoneNumber,
    sendOtpViaLeadToken,
    verifyOtpViaLeadToken,
    verifyOtp,
    emptyCart,
    addToCart,
    getCartDetails,
    removeFromCart
} from "./actions";
import { logoutUser, markUnauthorized } from "../../configuration/actions";
import { setMaskedPhone } from "../my-challans/actions";
import { getOrderList } from "../../shared/my-orders/actions";
import { setGaSource } from "../../shared/ga-source/actions";

const mapStateToProps = ({
    user: {
        mobile,
        userId,
        secureToken,
        isLoggedIn,
        isFetched: isUserDetailFetched
    },
    myChallans: {
        regNo,
        maskedPhone,
        name
    },
    gaSource: { source }
}) => ({
    mobile,
    userId,
    secureToken,
    regNo,
    isLoggedIn,
    isUserDetailFetched,
    maskedPhone,
    name,
    source
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
    createChallanProspectLeadConnect: createChallanProspectLead,
    getChallanListConnect: getChallanList,
    getChallanProspectLeadDetailsConnect: getChallanProspectLeadDetails,
    checkLeadPhoneNumberConnect: checkLeadPhoneNumber,
    sendOtpViaLeadTokenConnect: sendOtpViaLeadToken,
    verifyOtpViaLeadTokenConnect: verifyOtpViaLeadToken,
    logoutUserConnect: logoutUser,
    markUnauthorizedConnect: markUnauthorized,
    verifyOtpConnect: verifyOtp,
    setMaskedPhoneConnect: setMaskedPhone,
    emptyCartConnect: emptyCart,
    addToCartConnect: addToCart,
    getCartDetailsConnect: getCartDetails,
    removeFromCartConnect: removeFromCart,
    getOrderListConnect: getOrderList,
    setGaSourceConnect: setGaSource
}, dispatch);

export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(MyChallans)
);
